import { render, staticRenderFns } from "./AppMoneyComponent.vue?vue&type=template&id=09715943"
import script from "./AppMoneyComponent.vue?vue&type=script&lang=js"
export * from "./AppMoneyComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports